module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('p', {
    staticClass: "left"
  }, [_vm._v("\n    As seen on "), _c('a', {
    attrs: {
      "href": "http://www.boredbutton.com/",
      "target": "_blank"
    }
  }, [_vm._v("Bored Button")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("\n    By "), _c('a', {
    attrs: {
      "href": "http://scriptist.io",
      "target": "_blank"
    }
  }, [_vm._v("Scriptist")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-72444790!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 165
// module chunks = 2